export class Device {
  type: string;
  status: { add_date: string; remove_date: string; optout_flag: string };
  device_number: number;
  device_id: number;
  sdp_device_id: number;
  computer_guid: string;
  device_label: string;
  sub_type: string;
  platform_code: string;
  primary_use: string;
  data_plan: string;
  service_provider: string;
  bill_payer: string;
  primary_user: number;
  members_used: number[];
  minor_used_device_measuring_consent: string[];
  device_eligibility: string;
  check_page: boolean;

  constructor(obj?: any) {
    if (obj) {
      this.type = obj.type;
      this.status = obj.status;
      this.sub_type = obj.sub_type;
      this.data_plan = obj.data_plan;
      this.device_id = obj.device_id;
      this.device_number = obj.device_number;
      this.sdp_device_id = obj.sdp_device_id != null ? obj.sdp_device_id : 0;
      this.computer_guid =
        obj.computer_guid != null ? obj.computer_guid : 'null';
      this.bill_payer = obj.bill_payer;
      this.primary_use = obj.primary_use;
      this.device_label = obj.device_label;
      this.members_used = obj.members_used;
      this.primary_user = obj.primary_user;
      this.platform_code = obj.platform_code;
      this.service_provider = obj.service_provider;
      this.device_eligibility = obj.device_eligibility;
      this.minor_used_device_measuring_consent =
        obj.minor_used_device_measuring_consent.length > 0
          ? obj.minor_used_device_measuring_consent[0] != null
            ? obj.minor_used_device_measuring_consent
            : ['null']
          : ['null'];
      this.check_page = false;

    } else {
      this.type = 'null';
      this.status = {
        add_date: 'null',
        remove_date: 'null',
        optout_flag: 'N'
      };
      this.sub_type = 'null';
      this.data_plan = 'null';
      this.device_id = 0;
      this.device_number = 0;
      this.sdp_device_id = 0;
      this.computer_guid = 'null';
      this.bill_payer = 'null';
      this.primary_use = 'null';
      this.device_label = 'null';
      this.members_used = [];
      this.primary_user = 0;
      this.platform_code = 'null';
      this.service_provider = 'null';
      this.device_eligibility = 'null';
      this.minor_used_device_measuring_consent = ['null'];
      this.check_page = false;
    }
  }

  set deviceLabel(label: string) {
    this.device_label = label;
  }
}
